
import React, { useState } from 'react';

import Story from '../Components/Story';
import { apiCall } from '../api';


const StoryGenerator = () => {

    const [storyAbout, setStoryAbout] = useState('');

    const [storyId, setStoryId] = useState(null);
    const [storyTitle, setStoryTitle] = useState('');
    const [storyDescription, setStoryDescription] = useState('');


    const [setupComplete, setSetupComplete] = useState(false);


    const generateStory = async () => {

        setSetupComplete(true);

        // Make an API call to get the story title
        const [success, resp] = await apiCall({
            method: 'post',
            url: '/mikeyandeleanor/stories/create_story_title/',
            data: {
                details: storyAbout
            }
        });

        if (!success) {
            alert('There was a problem - try again!');
            return;
        }

        setStoryId(resp.id);
        setStoryTitle(resp.title);
        setStoryDescription(resp.description);

        // make an API call to start generating the story
        const [storySuccess, storyResp] = await apiCall({
            method: 'post',
            url: '/mikeyandeleanor/stories/create_story/',
            data: {
                story_id: resp.id
            }
        });

        if (!storySuccess) {
            alert('There was a problem - try again!');
            return;
        }

    };




    return (
        <div 
        className='story-generator-container'
        >

            {setupComplete === false && (


                <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: 'auto',
                    gap: '20px'
                }}
                >
                    <div
                    className='game-text'
                    style={{
                        width: '80%'
                    }}>
                        What would you like the story to be about?
                    </div>
                    <input
                        className='story-setup-input'
                        type='text'
                        placeholder='type here...'
                        value={storyAbout}
                        onChange={(e) => setStoryAbout(e.target.value)}
                    />
                    <div
                    className='story-time'
                    style={{
                        marginTop: '30px'
                    }}
                    onClick={() => generateStory()}
                    >
                        start story!
                    </div>
                </div>
                
                



                )}

            {setupComplete === true && (


                <Story 
                storyId={storyId}
                title={storyTitle}
                />

                                    
            
            )}



        </div>
    )
};

export default StoryGenerator;